import { render, staticRenderFns } from "./ShowAllNotifications.vue?vue&type=template&id=3de16a2d&scoped=true"
import script from "./ShowAllNotifications.vue?vue&type=script&lang=js"
export * from "./ShowAllNotifications.vue?vue&type=script&lang=js"
import style0 from "./ShowAllNotifications.vue?vue&type=style&index=0&id=3de16a2d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3de16a2d",
  null
  
)

export default component.exports